import { 
    LOAD_CONTROLLER_PERMISSIONS_DATA_IN_PROGRESS,
    LOAD_APP_ROLES_DATA_SUCCESS,
    LOAD_CONTROLLERS_LIST_DATA_SUCCESS,
    LOAD_CONTROLLER_PERMISSIONS_DATA_FAILURE, 
    LOAD_ROLE_CONTROLLER_PERMISSIONS_DATA_SUCCESS,
    LOAD_CONTROLLER_TENANT_PERMISSION_DATA_SUCCESS,
    LOAD_TENANT_ROLE_DATA_SUCCESS,
    CONTROLLER_PERMISSIONS_OPERATION_COMPLETED
  } from "./actions";
  
  const initialState = { isLoading: false, appRolesData:[], controllersListData:[], controllerRolePermissionList:[],tenantRolesList:[], controllersTenantPermission:[]};
  
  export const controllerPermissionData = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {    
        
        case LOAD_APP_ROLES_DATA_SUCCESS: {
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            appRolesData: data,
        };
        }
        case LOAD_CONTROLLER_PERMISSIONS_DATA_IN_PROGRESS:
        return {
            ...state,
            isLoading: true,
        };
        case LOAD_CONTROLLER_PERMISSIONS_DATA_FAILURE:
        return {
            ...state,
            isLoading: false,
        }; 
        case CONTROLLER_PERMISSIONS_OPERATION_COMPLETED:
        return {
            ...state,
            isLoading: false,
        }; 
        case LOAD_CONTROLLERS_LIST_DATA_SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                isLoading: false,
                controllersListData: data,
            };
        };
        case LOAD_ROLE_CONTROLLER_PERMISSIONS_DATA_SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                isLoading: false,
                controllerRolePermissionList: data,
            };
        };  
        case LOAD_CONTROLLER_TENANT_PERMISSION_DATA_SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                isLoading: false,
                controllersTenantPermission: data,
            };
        }; 
        case LOAD_TENANT_ROLE_DATA_SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                isLoading: false,
                tenantRolesList: data,
            };
        };   
        default:
        return state;
    }
  };
  